import * as wjcCore from "@grapecity/wijmo"
import React, { useCallback, useContext, useEffect, useState } from "react"
import TenkosyaInfo from "../../../../components/Tablet/TenkosyaInfo"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory, useParams } from "react-router-dom"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { TTenkoIcon名称, tenkoIcon } from "../../../../constant/icons"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../../globalStore/rootreducer"

import dateUtil from "../../../../ts/util/dateUtil"
import TabletTenkoService from "../../../../service/tablet/tabletTenkoService"
import { AppDispatch } from "../../../.."
import { setAlerts } from "../../../../globalStore/alertStore"
import { TenkoHeaderContext } from "../../context/context"
import { selectTenkoTypePage } from "../../../../constant/tablet/pages"

/**
 * 天気選択
 * @returns
 */
const SelectWeather = () => {
  const history = useHistory()
  const { date } = useParams<{ date: string }>()
  const { set点呼ヘッダ情報 } = useContext(TenkoHeaderContext)

  const dispatch: AppDispatch = useDispatch()
  const 営業日 = new Date().toISOString()
  const str営業日 = dateUtil.format(営業日, "YYYY年M月D日(dd)")
  const 点呼者 = useSelector((root: RootState) => root.user.LoginUserInfo)

  const [天候区分List, set天候区分List] = useState<区分マスタ[]>([])
  const [select天候区分, setSelect天候区分] = useState<区分マスタ>()

  const SelectWeather = (天候区分: 区分マスタ) => () => {
    setSelect天候区分(天候区分)
  }

  const create点呼ヘッダー = useCallback(async () => {
    try {
      const res = await new TabletTenkoService().upsertTenkoHeader({
        天候区分コード: select天候区分?.区分コード ?? "",
        部所コード: 点呼者.部所コード,
        点呼日: date ?? 営業日,
      })

      if (res.data) {
        set点呼ヘッダ情報(res.data)
        history.push(selectTenkoTypePage.Route.path)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }, [
    date,
    dispatch,
    history,
    select天候区分?.区分コード,
    set点呼ヘッダ情報,
    営業日,
    点呼者.部所コード,
  ])

  useEffect(() => {
    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.天候区分,
      }),
    ]).then(async ([天候区分Res]) => {
      天候区分Res && 天候区分Res.data && set天候区分List([...天候区分Res.data])
    })
  }, [])

  return (
    <>
      <TenkosyaInfo></TenkosyaInfo>
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100">
        <tbody>
          <tr>
            <td colSpan={天候区分List ? 天候区分List.length : 2}>
              {!wjcCore.isNullOrWhiteSpace(date ?? "") ? (
                <>{(dateUtil.format(date), "YYYY年M月D日(dd)")}</>
              ) : (
                <>{str営業日}</>
              )}
              の天気を選んでください
            </td>
          </tr>
          <tr>
            {天候区分List &&
              天候区分List.map((天候区分) => {
                const icon = tenkoIcon[`${天候区分.名称2}` as TTenkoIcon名称]
                const color = CSS_PROPERTY.WEATHER_COLOR[天候区分.名称2]
                return (
                  <td key={天候区分.区分ID}>
                    <GridButton
                      onTouchStartEventHandler={SelectWeather(天候区分)}
                      isSelected={天候区分.区分ID === select天候区分?.区分ID}>
                      <div
                        style={{
                          width: "100%",
                          margin: "auto",
                          textAlign: "center",
                        }}>
                        <div>
                          <FontAwesomeIcon icon={icon} style={{ color }} />
                        </div>
                        <div>
                          <span>{天候区分.名称1}</span>
                        </div>
                      </div>
                    </GridButton>
                  </td>
                )
              })}
          </tr>
          <tr>
            <td
              colSpan={天候区分List ? 天候区分List.length / 2 : 2}
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td
              colSpan={天候区分List ? 天候区分List.length / 2 : 2}
              className="align-bottom text-end">
              <div
                className="d-inline-block"
                onTouchStart={create点呼ヘッダー}
                style={{
                  bottom: "0",
                  backgroundColor: CSS_PROPERTY.WARN_COLOR,
                  color: "white",
                  width: "25rem",
                  textAlign: "center",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                }}>
                <span>確定</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectWeather
